import { useEffect } from 'react'

export type ArrowKeyDirection = 'up' | 'down'

type ArrowKeyHandlers = {
  onArrowPressed?: (direction: ArrowKeyDirection) => void
}

export const useArrowNavigation = (handlers: ArrowKeyHandlers) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return
      event.preventDefault()
      handlers.onArrowPressed?.(event.key === 'ArrowDown' ? 'down' : 'up')
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handlers])
}
